import { variables } from '@benefits/environment';

export const BASE_URL = variables.NEXT_API_URL;

export const ENDPOINTS = {
  features: {
    get: '/api/feature-toggles',
  },
};
